<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-epigraph element-without-heading" id="epigraph-2">
<div class="text" id="epigraph-2-text">
<p class="first first-in-chapter first-full-width"><i>This story appeared in the June 2016 issue of </i>Asimov’s Science Fiction<i> magazine. I was working on my First Contact novel, </i>Alien Morning<i> (Tor, 2016), at the time and gave serious consideration to plugging it into that novel. It seemed to stand so well on its own, however, that I ultimately decided to give the protagonist her own story. One of these days I’m going to write another story about Emma when she’s a little older and heading out for some new adventures.</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introductiontorambunctious.vue?0ff32ebe